import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { CustomList } from '@/models/interfaces'
import { CustomListsView, deleteCustomList } from '@/models/custom.lists'
import { RenameCustomListForm } from '@/models/custom.lists'

import ActionMenu from '@/app/components/ActionMenu.vue'
import Action from '@/app/components/ActionMenuItem.vue'
import ConfirmationPopup from '@/components/ui/ConfirmationPopup.vue'
import CustomListForm from './CustomListForm.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomListMenu',
  props: {
    list: {},
    listsView: {},
    positon: {}
  },
  setup(__props: any) {

const props = __props

const customListForm = ref<InstanceType<typeof CustomListForm> | null>(null)
const deletionPopup = ref<InstanceType<typeof ConfirmationPopup> | null>(null)

const router = useRouter()
const route = useRoute()

const isSingleListPage = computed(() => {
  return route.path === `/app/list/${props.list.url_slug}`
})

async function deleteList(): Promise<boolean> {
  return await deleteCustomList(
    props.list,
    isSingleListPage.value,
    props.listsView,
  )
}

const renameFormView = ref(
  new RenameCustomListForm(props.list, router, isSingleListPage.value),
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ActionMenu, {
      class: "custom-list-menu",
      position: __props.positon
    }, {
      default: _withCtx(() => [
        _createVNode(Action, {
          class: "custom-list-menu__btn--rename",
          icon: "iedit",
          onClick: _withModifiers(customListForm.value?.show, ["prevent"])
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" Rename ", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(Action, {
          class: "custom-list-menu__btn--delete",
          icon: "idelete",
          onClick: _withModifiers(deletionPopup.value?.show, ["prevent"])
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode(" Delete ", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["position"]),
    (_openBlock(), _createBlock(_Teleport, { to: "#appRoot" }, [
      _createVNode(CustomListForm, {
        ref_key: "customListForm",
        ref: customListForm,
        view: renameFormView.value
      }, null, 8, ["view"]),
      _createVNode(ConfirmationPopup, {
        ref_key: "deletionPopup",
        ref: deletionPopup,
        title: "Delete List",
        onCancel: () => true,
        onConfirm: deleteList,
        danger: true
      }, {
        confirm: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode(" Delete list ", -1)
        ]))]),
        default: _withCtx(() => [
          _cache[3] || (_cache[3] = _createTextVNode(" Are you sure you want to delete this list? ", -1))
        ]),
        _: 1
      }, 512)
    ]))
  ], 64))
}
}

})